(function(){
	angular.module('irricrops')
		.directive('browserWarning', function(){
			return{
				restrict     : 'E',
				templateUrl  : 'shared/browserWarning/browserWarning.tmpl.html',
				controllerAs : 'bw',
				controller   : ['$scope', 'deviceDetector',
				function($scope, deviceDetector){
					var vm      = this;
					vm.isChrome = (deviceDetector.browser === "chrome");
					//vm.isMobile = (window.innerWidth<800);
					vm.isMobile = false;

				}]
			}
		})
})();